import FormType from "@/models/Forms/FormType";

export default (formType: FormType) => {
    let returnVal = "Unknown"
    switch (formType) {
        case FormType.WorkerTermsConditions:
            returnVal = "Worker Terms & Conditions";
            break;
        case FormType.WorkerRightToWork:
            returnVal = "Worker Right To Work";
            break;
        case FormType.WorkerQualification:
            returnVal = "Worker Qualification";
            break;
    }
    return returnVal;
} 